module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="body-spacer"></div>\n    <p class="body">\n        Are you sure you want to delete all ineligible widgets from your experience to turn on Email mode? This action is permanent.\n    </p>\n<p class="custom-body"></p>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/email/PopupMessageView.tpl
// module id = 1774
// module chunks = 0